// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1SCMO","row":"Node_row__ZK2pT","label":"Node_label__33_gb","footer":"Node_footer__3Q4_e"};